import { useContext, useEffect, useRef } from 'react';
import { useLazyQuery, useQuery } from 'data-fetching-client';
import { GET_RECOMMENDED_ROLLOUT_PRODUCT_UPDATES, GET_ROLLOUT_PRODUCT_UPDATES } from '../queries';
import { getRequestParamsForGetRolloutProductUpdates, getRequestParamsForGetRolloutProductUpdatesByCategory } from '../utils';
import { NewToYouContext } from '../components/IndexPage';
import I18n from 'I18n';
import { selectHasNewToYouGate } from '../../app/auth/GateSelectors';
import { useAppSelector } from '../../app/indexReducer';
const useSideNavCounts = () => {
  var _newToYouData$rollout, _recommendedData$roll, _scheduledForReleaseD, _yourBetasData$rollou, _newToYouData$rollout3;
  // get recommended count from all product updates
  const {
    data: recommendedData
  } = useQuery(GET_RECOMMENDED_ROLLOUT_PRODUCT_UPDATES);

  // get count for all scheduled for release updates
  const {
    data: scheduledForReleaseData
  } = useQuery(GET_ROLLOUT_PRODUCT_UPDATES, {
    variables: getRequestParamsForGetRolloutProductUpdatesByCategory('scheduled-for-release', 'TABLE')
  });
  const paramsForGetYourBetas = getRequestParamsForGetRolloutProductUpdates({
    app: null,
    calendarTimestamp: null,
    endDate: null,
    impactLevels: null,
    isFavorite: null,
    limit: null,
    offset: null,
    product: null,
    query: null,
    recommended: null,
    rolloutState: null,
    startDate: null,
    type: null,
    view: null,
    category: 'your-betas',
    betaStatus: 'enrolled'
  });
  const {
    data: yourBetasData
  } = useQuery(GET_ROLLOUT_PRODUCT_UPDATES, {
    fetchPolicy: 'cache-and-network',
    variables: paramsForGetYourBetas
  });
  const hasNewToYouGate = useAppSelector(selectHasNewToYouGate);
  const {
    newToYouTimestamp
  } = useContext(NewToYouContext);
  const newToYouCountRef = useRef(undefined);
  const [getNewToYouData, {
    data: newToYouData
  }] = useLazyQuery(GET_ROLLOUT_PRODUCT_UPDATES, {
    fetchPolicy: 'network-only'
  });
  useEffect(() => {
    if (hasNewToYouGate && newToYouTimestamp) {
      getNewToYouData({
        variables: getRequestParamsForGetRolloutProductUpdates({
          app: null,
          calendarTimestamp: null,
          endDate: null,
          impactLevels: null,
          isFavorite: null,
          limit: null,
          offset: null,
          product: null,
          query: null,
          recommended: null,
          rolloutState: null,
          startDate: I18n.moment.utc(newToYouTimestamp).format('YYYY-MM-DD'),
          type: null,
          view: null,
          category: null,
          betaStatus: null
        })
      });
    }
  }, [hasNewToYouGate, newToYouTimestamp, getNewToYouData]);
  if (newToYouData !== null && newToYouData !== void 0 && (_newToYouData$rollout = newToYouData.rolloutProductUpdates) !== null && _newToYouData$rollout !== void 0 && _newToYouData$rollout.totalCount) {
    var _newToYouData$rollout2;
    newToYouCountRef.current = newToYouData === null || newToYouData === void 0 || (_newToYouData$rollout2 = newToYouData.rolloutProductUpdates) === null || _newToYouData$rollout2 === void 0 ? void 0 : _newToYouData$rollout2.totalCount;
  }
  return {
    recommendedCount: recommendedData === null || recommendedData === void 0 || (_recommendedData$roll = recommendedData.rolloutProductUpdates) === null || _recommendedData$roll === void 0 ? void 0 : _recommendedData$roll.totalCount,
    scheduledForReleaseCount: scheduledForReleaseData === null || scheduledForReleaseData === void 0 || (_scheduledForReleaseD = scheduledForReleaseData.rolloutProductUpdates) === null || _scheduledForReleaseD === void 0 ? void 0 : _scheduledForReleaseD.totalCount,
    yourBetasCount: (yourBetasData === null || yourBetasData === void 0 || (_yourBetasData$rollou = yourBetasData.rolloutProductUpdates) === null || _yourBetasData$rollou === void 0 ? void 0 : _yourBetasData$rollou.totalCount) || 0,
    newToYouCount: newToYouData === null || newToYouData === void 0 || (_newToYouData$rollout3 = newToYouData.rolloutProductUpdates) === null || _newToYouData$rollout3 === void 0 ? void 0 : _newToYouData$rollout3.totalCount
  };
};
export default useSideNavCounts;